import React from "react";

const Input = ({ value, setValue, placeholder = "", type, className, targetValue = "value", ...other }) => (
    <input
        className={className}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(event) => setValue(event.target[targetValue])}
        {...other}
    />
);

export default Input;
